import { a as u } from "../add-FrnMPwwO.mjs";
import { f as i } from "../format-plq8pBNY.mjs";
import { s as w } from "../sub-CkNH5u-l.mjs";
import { convert12to24 as h } from "./helpers.js";
import { g } from "../index-C8O1hjfH.mjs";
const S = () => {
  const n = /* @__PURE__ */ new Date();
  let e = n.toLocaleString("en-US", { timeZone: "America/New_York" }), [r, t] = e.split(",");
  const o = Number.parseInt(t.split(":")[0], 10);
  if (t.includes("AM") && (o < 6 || o === 12)) {
    e = new Date(w(n, { days: 1 })).toLocaleString("en-US", { timeZone: "America/New_York" });
    const c = e.split(",");
    r = c[0], t = c[1];
  }
  const [s, a, m] = r.split("/"), [l, p] = t.trim().split(" "), [y, d] = l.split(":"), f = h(`${y}:${d} ${p}`);
  return i(/* @__PURE__ */ new Date(`${m}-${s.length < 2 ? "0" + s : s}-${a.length < 2 ? "0" + a : a}T${f}:00`), "yyyy-MM-dd");
}, N = () => {
  const n = /* @__PURE__ */ new Date(`${S()}T00:00:00`);
  let e = [];
  for (let r = 0; r <= 13; ++r) {
    const t = u(n, { days: r });
    e.push({
      dayStr: r === 0 ? "Today" : i(t, "EEE"),
      monthStr: i(t, "MMM"),
      dateStr: i(t, "d"),
      fullDateStr: i(t, "yyyy-MM-dd"),
      date: t
    });
  }
  return e;
}, E = (n, e) => {
  if (!Array.isArray(n))
    throw new TypeError("First argument must be an array");
  if (typeof e != "number" || e <= 0)
    throw new TypeError("Second argument must be a positive number");
  const r = [];
  for (let t = 0; t < n.length; t += e)
    r.push(n.slice(t, t + e));
  return r;
}, T = (n, e) => {
  const r = /* @__PURE__ */ new Date(), t = g("America/New_York", new Date(n)) / 36e5, o = /* @__PURE__ */ new Date(`${n}:00-0${t * -1}:00`), [s, a] = e.split(":"), m = Number.parseInt(s, 10) * 60 + Number.parseInt(a, 10);
  return r >= o && r <= u(o, { minutes: m });
};
export {
  E as chunkArray,
  N as create2WeeksList,
  T as determineIfShowIsOnNow,
  S as getCurrentEasternProgrammingDateStr
};
